import shared from "../../data/js/shared";

const {
  viewDealSoldByLabel,
  viewDealOpensInNewTab,
  viewDealTrustNote,
  viewDealTrustNoteCars,
} = shared.product;

interface ViewDealDetailsProps {
  partnerName: string;
  shippingOptional?: boolean;
}

const ViewDealDetails = ({ partnerName, shippingOptional = false }: ViewDealDetailsProps) => {
  const sentencePartner = partnerName.charAt(0).toUpperCase() + partnerName.slice(1);
  const template = shippingOptional ? viewDealTrustNoteCars : viewDealTrustNote;
  const trustNote = template
    .replaceAll("{partnerCap}", sentencePartner)
    .replaceAll("{partner}", partnerName);

  return (
    <div className="view-deal-details same-color-border">
      <div className="view-deal-trust">
        <div className="view-deal-new-tab">
          {/* Inline, not an <img>, so the arrow takes the text colour in both themes. */}
          <svg viewBox="0 0 16 12" aria-hidden="true" focusable="false">
            <path
              fill="currentColor"
              d="M10.7742 0.544197C10.5562 0.318601 10.1935 0.318601 9.96786 0.544197C9.74989 0.762171 9.74989 1.12495 9.96786 1.34242L14.0565 5.43108H0.564497C0.249984 5.43159 0 5.68157 0 5.99609C0 6.3106 0.249984 6.56871 0.564497 6.56871H14.0565L9.96786 10.6498C9.74989 10.8753 9.74989 11.2386 9.96786 11.4561C10.1935 11.6817 10.5567 11.6817 10.7742 11.4561L15.8308 6.39952C16.0564 6.18154 16.0564 5.81876 15.8308 5.60129L10.7742 0.544197Z"
            />
          </svg>
          <span>{viewDealOpensInNewTab}</span>
        </div>
        <p className="view-deal-trust-note">{trustNote}</p>
      </div>
      <div className="view-deal-sold-by">
        <span>{viewDealSoldByLabel}</span>
        <strong>{partnerName}</strong>
      </div>
    </div>
  );
};

export default ViewDealDetails;
